import {Component, h} from 'preact';

import {connect} from 'preact-redux';
import Popup from "../popup/Popup";
import {formatNumber} from "../../utils/number";
import {refreshOffers} from "../../utils/offers";
import axios from "axios";

class WelcomeTextInternal extends Component {

    constructor(props) {
        super(props);
        this.state = {popup: false}
    }

    banks() {
        const {offers} = this.props;
        let length = offers.length;
        if (length % 10 === 1 && length !== 11) {
            return `от ${offers.length} банка`
        }
        return `от ${offers.length} банков`
    };

    componentDidMount() {
        const isDesktop = document.body.clientWidth >= 800;

        if (isDesktop) {
            document.addEventListener('click', e => this.checkClickOutside(e))
        }
    }

    render({offers, userData}) {

        const isAdaptive = document.body.clientWidth < 800;
        const extraSmall = document.body.clientWidth <= 412;

        if (offers && offers.length) {
            const minEP = offers.map(o => o.monthlyPayment).reduce((accumulator, currentValue) => (accumulator < currentValue ? accumulator : currentValue));
            const text = [
                !extraSmall ? `У вас есть одобрение ${this.banks()} от ` : "Ипотека от ",
                <span className={"fw-offers_root_payment"}>
                    {`${formatNumber(minEP)} Р/Мес`}
                </span>
            ];
            let ret = <div className={'fw-offers_root'}>
                <div style={{
                    cursor: 'pointer',
                    borderBottom: isAdaptive && this.state.popup ? '1px solid #d8d8d8' : ""
                }} className={"fw-offers_titleBox"} onClick={() => this.togglePopup()}
                >

                    <span className={'mobile-house'}/>
                    <span>
                        {text}
                        {isAdaptive ?
                            <div
                                className={'fw-offers_arrow_icon'}
                                style={{transform: this.state.popup ? 'rotate(180deg)' : "rotate(0deg)"}}
                            /> : null}
                    </span>
                </div>
                {this.state.popup ? <Popup popupRef={node => this.dropdownNode = node}/> : null}
            </div>;
            return ret
        }
        return null;
    }

    checkClickOutside(e) {
        if (
            this.state.popup && !e.path.some(node => this.dropdownNode === node)
        ) {
            this.setState({popup: false});
        }
    };

    togglePopup() {
        if (this.state.popup) {
            this.setState({popup: false})
        } else {
            axios.post("https://widget-statistics.fin.cian.ru/widgets/events/finance-widget-offers-on-card", {
                name: "opened",
                abGroup: this.props.userData ? this.props.userData.abGroup : 100
            }, {withCredentials: true, timeout: 2000})
                .catch((e) => console.log('error while send opened event: ', e));
            refreshOffers().then(() => this.setState({popup: !this.state.popup}));
        }
    }
}

const WelcomeText = connect(
    state => state
)(WelcomeTextInternal);


export default WelcomeText;
